/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsSerialNumberListItem,
    MelcoModelsSerialNumberListItemFromJSON,
    MelcoModelsSerialNumberListItemFromJSONTyped,
    MelcoModelsSerialNumberListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsSerialNumberListItem
 */
export interface MelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    /**
     * 
     * @type {Array<MelcoModelsSerialNumberListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    list: Array<MelcoModelsSerialNumberListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    return MelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsSerialNumberListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsSerialNumberListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsSerialNumberListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsSerialNumberListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


